<template>
  <img :src="require('@/assets/images/blog/' + source)" class="w-screen mb-25" alt="">
</template>

<script>
export default {
  name: "imageElement",
  props: ['source']
}
</script>

<style scoped>

</style>